import { useEffect, useState } from "react";
import { SessionIdentity, tokenStore } from "@services/tokenStore";

export type Session = {
  sessionId: string;
  personId: string;
  accountId: string;
};

const useSessionIdentity = (): SessionIdentity | undefined => {
  const [identity, setIdentity] = useState(() => tokenStore.getIdentity());

  useEffect(() => {
    setIdentity(tokenStore.getIdentity());
    return tokenStore.subscribe(() => {
      setIdentity(tokenStore.getIdentity());
    });
  }, []);

  return identity;
};

export const useSession = (): Session => {
  const identity = useSessionIdentity();

  return {
    sessionId: identity?.sessionId as string,
    personId: identity?.personId as string,
    accountId: identity?.accountId as string
  };
};

export const useHasSession = (): boolean => !!useSessionIdentity();
